var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84648 2.58828C9.84648 3.47194 9.13013 4.18828 8.24648 4.18828C7.36284 4.18828 6.64648 3.47194 6.64648 2.58828C6.64648 1.70462 7.36284 0.988281 8.24648 0.988281C9.13013 0.988281 9.84648 1.70462 9.84648 2.58828ZM9.84648 7.70827C9.84648 8.59192 9.13013 9.30827 8.24648 9.30827C7.36284 9.30827 6.64648 8.59192 6.64648 7.70827C6.64648 6.82462 7.36284 6.10828 8.24648 6.10828C9.13013 6.10828 9.84648 6.82462 9.84648 7.70827ZM8.24648 14.4283C9.13013 14.4283 9.84648 13.7119 9.84648 12.8283C9.84648 11.9446 9.13013 11.2283 8.24648 11.2283C7.36284 11.2283 6.64648 11.9446 6.64648 12.8283C6.64648 13.7119 7.36284 14.4283 8.24648 14.4283Z",
    fill: "#F4FDFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebab);
export default __webpack_public_path__ + "static/media/kebab.3586e83190aa3a6c1b923a442a902b60.svg";
export { ForwardRef as ReactComponent };